package kz.dentalcrm.app.core.ui.utils

import androidx.compose.ui.graphics.Color

fun String.toColor(): Color {
    return Color(this.removePrefix("#").toLong(16) or 0x00000000FF000000)
}